import {
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  viewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { DriverTypeService } from '../../../../core/services/doctor/driver-type/driver-type.service'
import { HealthUnitService } from '../../../../core/services/health-unit/location/health-unit.service'
import { SubtypeExamService } from '../../../../core/services/subtype-exam/subtype-exam/subtype-exam.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { convertCurrency } from '../../../../shared/utils/utils'
import moment from 'moment'
import { ModalSupplierComponent } from '../../../person/supplier/modal_supplier/modal-supplier.component'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { provideNgxMask } from 'ngx-mask'
import { MatDivider } from '@angular/material/divider'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs'
import { MatCheckbox } from '@angular/material/checkbox'
import {PagedContactTypeResponse} from '../../../../core/models/contact-type.model';
import {SupplierService} from '../../../../core/services/person/supplier/supplier.service';
import {ExamTypeService} from '../../../../core/services/exam-type/document-type/exam-type.service';
import {
  UnitMeasureTypeService
} from '../../../../core/services/tax-document/tax-document-type/unit-measure-type.service';
import {DoctorService} from '../../../../core/services/doctor/driver/doctor.service';
import {
  MonitoringService
} from '../../../../core/services/monitoring/legal-entity-client/monitoring.service';
import {ContextService} from '../../../../core/services/context/context.service';

@Component({
  selector: 'exam-patient-form-edit',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatTabsModule,
  ],
  templateUrl: './exam-relation-patient-form-edit.component.html',
  styleUrl: './exam-relation-patient-form-edit.component.scss',
  providers: [
    DriverTypeService,
    HealthUnitService,
    SubtypeExamService,
    VehicleTypeService,
    MonitoringService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ExamRelationPatientFormEditComponent implements OnInit {
  constructor(
    private tariffService: MonitoringService,
    private supplierService: SupplierService,
    private examTypeService: ExamTypeService,
    private monitoringService: MonitoringService,
    private taxDocumentTypeService: UnitMeasureTypeService,
    private specificationService: SubtypeExamService,
    private doctorService: DoctorService,
    private formBuilder: FormBuilder,
    private contextService: ContextService,
    private dialogRef: MatDialogRef<ExamRelationPatientFormEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {
    this.idClient = data.idClient
    this.equipamento = data.equipamento;
    if (data && data.edit) {
      this.edit = true
      this.item = data.item
    }
  }

  datepicker = viewChild<MatDatepicker<any>>('birth')
  @Output() response = new EventEmitter()
  @ViewChild('tabGroup') tabGroup: MatTabGroup | undefined
  equipamento: { id: string, modelo: string, numero_serial: string };
  subtipoExameEnable: boolean = false
  equipamentoEnable: boolean = false
  idClient: number = 0
  edit: boolean = false
  item: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listServiceSpecification: any[] = []
  listTipoExames: any[] = []
  doctorsList: any[] = []
  listEquipamentos: any[] = []
  listUnidadesMedida: any[] = []
  listSubtipoExames: any[] = []
  supplierSelected: any = {}
  formParametro: FormGroup = new FormGroup({})
  listLocation: any[] = []
  listAlertas: any[] = []
  listContextos: any[] = []
  parametros: any[] = []
  editingParametroIndex: number = -1

  ngOnInit(): void {
    this.getDocs()
    this.getListItems()
    this.getTipoExame()
    this.createForm()
    this.getContextos()
    this.createFormParametro()
    this.getAlertas()

    this.form.get('examType')?.valueChanges.subscribe(() => {
      this.getSubtipoExame()
      this.subtipoExameEnable = true
      // this.getEquipamentos()
      // this.equipamentoEnable = true

    })
    if (this.edit) {
      this.fillForm(this.item)
    }
  }

  getAlertas() {
    this.supplierService.listEquipmentsByTypeExam(this.form.get("alert")!.value).subscribe({
      next: (response: ResponseRequestModel) => {
        this.listAlertas = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
      },
    })
  }

  getContextos() {
    this.contextService.listContext().subscribe({
      next: (response: ResponseRequestModel) => {
        if (response.data) {
          this.listContextos = response.data
        }
      }, error: (err: ResponseRequestModel) => {
        console.error(err)
      }, complete: () => {
        this.fillFormParametros()
      },

    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  FinishMonitoring() {
    const model = {id_paciente: this.idClient, id_exame: this.item.id}
    this.monitoringService.finishMonitoring(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.response.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  checkEdit() {
    if (this.edit) {
      if (this.item.id) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm(this.item)
    }
  }

  createPayload() {
    const usarParametrosPersonalizados = this.form.get('parameterPattern')!.value;

    // Base comum para ambos (create/edit)
    let modelBase: any = {
      descricao: this.form.get('descricao')!.value,
      tipo_exame_id: this.form.get('examType')!.value,
      subtipo_exame: this.form.get('examSubType')!.value,
      tutorlocal_id: this.form.get('idMedico')!.value,
      tutorlocal_associado_id: this.form.get('idMedico')!.value,
    };

    // Se estiver editando, inclui o ID do item
    if (this.edit) {
      modelBase.id = this.item.id;
    } else {
      // Se for novo registro, inclui o paciente vinculado
      modelBase.paciente_id = this.idClient;
    }

    // Caso esteja usando parâmetros personalizados
    if (usarParametrosPersonalizados && this.parametros?.length > 0) {
      modelBase.usar_parametros_personalizados = true;

      if (this.parametros.length > 1) {
        // múltiplos parâmetros → usa array completo
        modelBase.parametros = this.parametros;
      } else {
        // único parâmetro → formato simplificado
        const param = this.parametros[0];
        modelBase.parametro_minimo = param.parametro_minimo;
        modelBase.parametro_maximo = param.parametro_maximo;
        modelBase.tipo_unidade = param.tipo_unidade;
        modelBase.contexto_id = param.contexto_id;
      }
    }
    return modelBase;
  }

  addTariff() {
    this.loading = true
    const model = this.createPayload()
    if (this.edit) {
      this.tariffService.editMonitoringForPatient(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
    } else {
      this.tariffService.createMonitoringForPatient(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
    }
  }

  checkForm() {
    const usarParametros = this.form.get('parameterPattern')?.value;

    if (this.form.valid) {
      // Se usar parâmetros personalizados, verifica se tem pelo menos um parâmetro
      if (usarParametros && this.parametros.length === 0) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.dialogRef.close()
  }

  getDescription(id: number, list: any[]) {
    if (list == this.listEquipamentos) {
      let index = list.findIndex((ele) => {
        return ele.id == id
      })
      return index > -1 ? `${list[index].modelo} - ${list[index].numero_serial}` : ''
    }
    if (list == this.doctorsList) {
      let index = list.findIndex((ele) => {
        return ele.id == id
      })
      return index > -1 ? list[index].nome_principal : ''
    }
    if (list == this.listContextos) {
      let index = list.findIndex((ele) => {
        return ele.id == id
      })
      if (index === undefined || index === null) {
        index = list.findIndex((ele) => {
          return ele.contexto_id == id
        })
      }
      return index > -1 ? list[index].nome : ''
    }
    if (list == this.listUnidadesMedida) {
      let index = list.findIndex((ele) => {
        return ele.id == id
      })
      return index > -1 ? list[index].tipo_unidade : ''
    }
    let index = list.findIndex((ele) => {
      return ele.id == id
    })
    return index > -1 ? list[index].descricao : ''
  }

  getSubtipoExame() {
    this.specificationService.listSubTypeExamByTypeExam(this.form.get("examType")!.value).subscribe({
      next: (response: ResponseRequestModel) => {
        // @ts-ignore
        this.listSubtipoExames = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
      },
    })
  }

  getDocs() {
    this.doctorService.listDoctors().subscribe({
      next: (response: ResponseRequestModel) => {
        this.doctorsList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
      },
    })
  }

  getEquipamentos() {
    this.supplierService.listEquipmentsByTypeExam(this.form.get("examType")!.value).subscribe({
      next: (response: ResponseRequestModel) => {
        if (response.data.length > 0) {
          this.listEquipamentos = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
      },
    })
  }

  getTipoExame() {
    this.examTypeService.listExamType().subscribe({
      next: (response: ResponseRequestModel) => {
        // @ts-ignore
        this.listTipoExames = response.data.map(item => ({
            ...item,
            id: Number(item.id)
          })
        )
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
      },
    })
  }

  getListItems() {
    this.loading = true
    this.taxDocumentTypeService
      .listPagedTaxDocumentType()
      .subscribe({
        next: (response: any) => {
          this.listUnidadesMedida = response.data
        },
        error: (err: PagedContactTypeResponse) => {
        },
        complete: () => {
          this.loading = false
          this.fillFormParametros()
        },
      })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      alert: [null],
      examType: [null, [Validators.required]],
      examSubType: [{value: null, disabled: true}, [Validators.required]],
      parameterPattern: [false],
      descricao: ['', [Validators.required]],
      idMedico: [null],
    })

  }

  createFormParametro(): void {
    this.formParametro = this.formBuilder.group({
      contexto: [null, [Validators.required]],
      parametro_minimo: ['', [Validators.required]],
      parametro_maximo: ['', [Validators.required]],
      tipo_unidade: [null, [Validators.required]],
    })
  }

  addParametro() {
    if (this.formParametro.valid) {
      const parametro = {
        contexto_id: this.formParametro.get('contexto')!.value,
        parametro_minimo: this.formParametro.get('parametro_minimo')!.value,
        parametro_maximo: this.formParametro.get('parametro_maximo')!.value,
        tipo_unidade: this.formParametro.get('tipo_unidade')!.value,
        contextoDescricao: this.getDescription(this.formParametro.get('contexto')!.value, this.listContextos),
        tipoUnidadeDescricao: this.getDescription(this.formParametro.get('tipo_unidade')!.value, this.listUnidadesMedida),
      };

      if (this.editingParametroIndex >= 0) {
        // Editando parâmetro existente
        this.parametros[this.editingParametroIndex] = parametro;
        this.editingParametroIndex = -1;
      } else {
        // Adicionando novo parâmetro
        this.parametros.push(parametro);
      }

      this.formParametro.reset();
      this.snackbar.success('Parâmetro adicionado com sucesso!');
    }
  }

  editParametro(index: number) {
    const parametro = this.parametros[index];
    this.formParametro.patchValue({
      contexto: parametro.contexto_id,
      parametro_minimo: parametro.parametro_minimo,
      parametro_maximo: parametro.parametro_maximo,
      tipo_unidade: parametro.tipo_unidade,
    });
    this.editingParametroIndex = index;
  }

  removeParametro(index: number) {
    this.parametros.splice(index, 1);
    let parametro = this.parametros[index];
    this.snackbar.success('Parâmetro removido!');
  }

  cancelEditParametro() {
    this.formParametro.reset();
    this.editingParametroIndex = -1;
  }

  fillForm(item: any, alterTab: boolean = false) {
    if (item) {
      this.form.patchValue({
        examType: this.item.tipo_exame_id,
        examSubType: this.item.subtipoexame_id,
        idMedico: this.item.tutorlocal_id,
        descricao: this.item.descricao,
        parameterPattern: this.item.parametros && this.item.parametros.length > 0, // habilita toggle
      });
      this.form.get("examSubType")?.disable()
      this.form.get("examType")?.disable()
      // 🔹 Zera e preenche lista local de parâmetros
      this.parametros = [];

      if (this.item.parametros && this.item.parametros.length > 0 && this.listContextos.length>0 && this.listUnidadesMedida.length>0) {
        this.parametros = this.item.parametros.map((param: any) => ({
          id: param.id,
          contexto_id: param.contexto_id,
          parametro_minimo: Number(param.parametro_minimo),
          parametro_maximo: Number(param.parametro_maximo),
          tipo_unidade: param.tipo_unidade,
          // se quiser exibir textos descritivos:
          contextoDescricao: this.listContextos.find(c => c.id === param.contexto_id)?.nome || '',
          tipoUnidadeDescricao: this.listUnidadesMedida.find(u => u.id === param.tipo_unidade)?.tipo_unidade || ''
        }));
      }
    }
  }
  fillFormParametros(){
    if (this.item.parametros && this.item.parametros.length > 0 && this.listContextos.length>0 && this.listUnidadesMedida.length>0) {
      this.parametros = this.item.parametros.map((param: any) => ({
        id: param.id,
        contexto_id: param.contexto_id,
        parametro_minimo: Number(param.parametro_minimo),
        parametro_maximo: Number(param.parametro_maximo),
        tipo_unidade: param.tipo_unidade,
        // se quiser exibir textos descritivos:
        contextoDescricao: this.listContextos.find(c => c.id === param.contexto_id)?.nome || '',
        tipoUnidadeDescricao: this.listUnidadesMedida.find(u => u.id === param.tipo_unidade)?.tipo_unidade || ''
      }));
    }
  }
  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    let specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService?: any) {
    const enabled = this.form.get('parameterPattern')?.value;

    if (enabled) {
      this.form.get('parameterMin')?.enable();
      this.form.get('parameterMax')?.enable();
    } else {
      this.form.get('parameterMin')?.disable();
      this.form.get('parameterMax')?.disable();
    }
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  selectItem(item: any) {
    this.fillForm(item, true)
  }
}
